import React from 'react';
import AddOnCard from './AddOnCard';

type ServiceProviderAnalyticsCardV2Props = {
  hasOTT: boolean;
  hasCDN: boolean;
  hasMarketIntel: boolean;
};
const ServiceProviderAnalyticsCardV2 = ({ hasOTT, hasCDN, hasMarketIntel }: ServiceProviderAnalyticsCardV2Props) => {
  const spaInfo = { title: 'Service Provider Analytics', description: 'SP-ANALYTICS' };
  const spaExtensions = [
    {
      key: 'OTT Service Tracking',
      value: hasOTT ? 'Enabled' : 'Disabled'
    },
    {
      key: 'CDN Analytics',
      value: hasCDN ? 'Enabled' : 'Disabled'
    },
    {
      key: 'Market Intelligence',
      value: hasMarketIntel ? 'Enabled' : 'Disabled'
    }
  ];

  return <AddOnCard title={spaInfo.title} description={spaInfo.description} extensions={spaExtensions} />;
};

export default ServiceProviderAnalyticsCardV2;
